<!-- Historial de modificaciones: qué cambió, quién y cuándo, por elemento. -->

@if (isSlowConnection) {
  <div class="alert">⚠ La conexión de internet es lenta.</div>
}

<app-page-title [title]="pageLabel()" backRoute="/audit/menu" backTooltip="Regresar al menú de auditoría"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="pageLabel()" (retry)="init()"></app-page-loader>

<div class="table-section">
  <!-- Elige el módulo (y opcionalmente el tipo de edición) y presiona Consultar -->
  <div class="filter-bar filter-bar--flush">
    <div class="filter-card">
      <app-search-pill [value]="textFilter" [disabled]="uiData.length === 0" placeholder="Nombre, campo, valor o usuario…" (search)="filterText($event)"></app-search-pill>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-card__wide">
        <mat-label>Módulo</mat-label>
        <mat-select [(value)]="selectedTable" (selectionChange)="resetModule()" [disabled]="toolSpinner">
          @for (m of moduleOptions; track m.value) {
            <mat-option [value]="m.value">{{ m.name }}</mat-option>
          }
        </mat-select>
        <mat-icon matPrefix>apps</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Tipo de edición</mat-label>
        <mat-select [(value)]="kindFilter" (selectionChange)="applyView()">
          @for (k of kindOptions; track k.value) {
            <mat-option [value]="k.value">{{ k.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button mat-flat-button color="primary" class="apply-btn" (click)="getHistory()" [disabled]="toolSpinner || !selectedTable">
        <mat-icon>manage_search</mat-icon> Consultar
      </button>
      <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
      <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
      <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
    </mat-button-toggle-group>
    </div>
    <app-filter-chips [chips]="filterChips" (remove)="removeChip($event)" (clear)="removeChip('kind')"></app-filter-chips>
  </div>

  @if (toolSpinner) {
    <div class="loading-row"><mat-spinner diameter="32"></mat-spinner><span>Cargando...</span></div>
  }

  @if (pagedList.length > 0) {
    <div class="list-actions">
      <button mat-flat-button color="primary" (click)="_downloadReport()">
        <mat-icon>download</mat-icon> Descargar Excel
      </button>
    </div>
    <div class="indicators">
      <span class="total-badge"><b>{{ selectedModuleLabel }} · {{ viewData.length }} registro(s)</b></span>
      <mat-paginator class="spacer" [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = OnPageChange($event)"></mat-paginator>
    </div>

    @if (listView.mode === 'cards') {
      <div class="inv-cards cat-cards">
        @for (data of pagedList; track data) {
          <div class="cat-card">
            <div class="cat-card__head">
              <mat-icon class="card-icon">tag</mat-icon>
              <span class="cat-card__title">{{ data.element }}</span>
              <span class="list-status">{{ data.movements?.length ?? 0 }} cambio(s)</span>
            </div>
            <div class="cat-card__body">
              <div class="cat-card__field"><span class="cat-card__label">Última modificación:</span><span class="cat-card__value">{{ data.modifiedOn }}</span></div>
              <div class="move-list">
                @for (move of data.movements; track move) {
                  <div class="move-item">
                    <div class="move-item__top">
                      <span [class]="kindClass(move.kind)">{{ move.kind }}</span>
                      <b>{{ move.attribute }}</b>
                    </div>
                    @if (move.before || move.after) {
                      <div class="move-item__change"><span class="before">{{ move.before || '—' }}</span><mat-icon>arrow_forward</mat-icon><span class="after">{{ move.after || '—' }}</span></div>
                    }
                    <small>{{ move.modifiedOn }} · {{ move.modifiedBy }}</small>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }

    <div class="table-container mat-elevation-z2" [hidden]="listView.mode !== 'table'">
      @for (data of pagedList; track data) {
        <div class="element-block">
          <div class="element-block__head">
            <mat-icon>tag</mat-icon>
            <b>{{ data.element }}</b>
            <span class="element-block__meta">Última modificación: {{ data.modifiedOn }}</span>
            <span class="element-block__meta">{{ data.movements?.length ?? 0 }} cambio(s)</span>
          </div>
          <table class="moves-table">
            <tr>
              <th>Tipo</th>
              <th>Atributo modificado</th>
              <th>Valor anterior</th>
              <th>Valor posterior</th>
              <th>Fecha</th>
              <th>Modificado por</th>
            </tr>
            @for (move of data.movements; track move) {
              <tr>
                <td><span [class]="kindClass(move.kind)">{{ move.kind }}</span></td>
                <td>{{ move.attribute }}</td>
                <td class="before">{{ move.before }}</td>
                <td class="after">{{ move.after }}</td>
                <td>{{ move.modifiedOn }}</td>
                <td>{{ move.modifiedBy }}</td>
              </tr>
            }
          </table>
        </div>
      }
    </div>
  } @else if (loaded && !toolSpinner) {
    <div class="no-data panel"><mat-icon>inbox</mat-icon><span>Sin historial para este módulo con los filtros elegidos</span></div>
  } @else if (!toolSpinner) {
    <div class="no-data panel">
      <mat-icon>manage_search</mat-icon>
      <span>Elige un <b>módulo</b> y presiona <b>Buscar historial</b>. Puedes filtrar por tipo: <b>creado</b>, <b>editado</b> o <b>borrado</b>.</span>
    </div>
  }
</div>
